import { Pipe, PipeTransform } from '@angular/core';
import { LuxonDateService } from '../../../services/luxon-date.service';

@Pipe({
  name: 'luxonDateFormat',
  standalone: true
})
export class LuxonDateFormatPipe implements PipeTransform {
  constructor(private luxonDate: LuxonDateService) { }

  transform(value: string | Date | null | undefined, format: string = 'dd-MM-yyyy'): string {
    if (!value) return '';

    const parsed = this.luxonDate.parse(value);
    if (!parsed || !parsed.isValid) return '';

    return parsed.toFormat(format);
  }
}
